module.exports = __webpack_public_path__ + "d767fea14731b820673d8be52c6db24b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/3.jpg
// module id = 275
// module chunks = 0